export default __webpack_public_path__ + "static/media/pantry1-afterE-480w.f7851f3b.avif";